export default __webpack_public_path__ + "static/media/person-with-key.74e13ada.svg";